export const appLocales = {
  EN_US: 'en_US',
  EN_CA: 'en_CA',
  FR_CA: 'fr_CA',
  PT_BR: 'pt_BR',
  ES_MX: 'es_MX',
  ES_LATAM: 'es_419',
};
